import Image from './Image';
import Rendition from './Rendition';

export default Image;
export { Image, Rendition };
